import { cn } from '@/lib/utils';

type BrandLogoProps = {
  className?: string;
  /** Full wordmark (logo.png) or compact pm mark (favicon.png) */
  variant?: 'full' | 'mark';
  alt?: string;
};

export function BrandLogo({
  className,
  variant = 'full',
  alt = 'Payroll Mauritius',
}: BrandLogoProps) {
  const src = variant === 'mark' ? '/favicon.png' : '/logo.png';

  return <img src={src} alt={alt} className={cn('object-contain', className)} draggable={false} />;
}
